<section class="section white-100" *ngIf="exploreMorePanelData">
  <div class="section-container">
    <h2 class="section-heading mar-b-32">
      {{ exploreMorePanelData?.title }}
    </h2>
    <p class="section-description mar-b-48 align-c" *ngIf="exploreMorePanelData?.content">
      <span class="wid-75">
        {{ exploreMorePanelData?.content?.content[0] | toHtml }}
      </span>
    </p>
    <div class="section-explore-more">
      <ng-container *ngFor="let item of exploreMorePanelData?.component1">
        <div class="explore-more" [ngClass]="noRedirect ? 'no-pointer' : ''">
          <div class="product-landing-content">
            <h5 class="explore-more-heading">
              {{ item?.fields?.richTextTitle?.content[0] | toHtml}}
              <img
                loading="lazy"
                class="mar-l-8"
                src="{{ item?.fields?.iconImage?.fields?.file?.url }}"
                alt=""
              />
            </h5>
            <p class="product-landing-description">
              {{ item?.fields?.description?.content[0]?.content[0]?.value }}
            </p>
          </div>
          <figure>
            <img
              loading="lazy"
              src="{{ item?.fields?.imageicon?.fields?.file?.url }}"
              alt="{{ item?.fields?.imageicon?.fields?.title }}"
              class="product-landing-img"
            />
          </figure>
          <ng-container *ngIf="!noRedirect">
            <a class="explore-more-link" 
               [href]="item?.fields?.link | urlParams:queryParams"
               (click)="onProductCardClick(item?.fields?.richTextTitle?.content[0]?.content[0]?.value, item?.fields?.link)"
            ></a>
          </ng-container>
        </div>
      </ng-container>
    </div>
  </div>
</section>
